import React from 'react';
import { MdWarning, MdRefresh } from 'react-icons/md';
import PropTypes from 'prop-types';

function FatalError({ error, hideRefresh }) {
  return (
    <div className="h-full flex flex-col items-center justify-center">
      <MdWarning size={150} color="var(--warning)" />
      <div className="flex flex-col w-1/2 text-center items-center text-xl">
        <h2>Une erreur est survenue: </h2>
        <h2 className="text-red-400 mb-8">{error}</h2>
        {!hideRefresh && (
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="flex items-center space-x-1 bg-zinc-700 py-2 px-4 hover:bg-zinc-600 duration-300 rounded"
          >
            <MdRefresh />
            <span>Actualiser</span>
          </button>
        )}
      </div>
    </div>
  );
}

FatalError.propTypes = {
  error: PropTypes.string,
  hideRefresh: PropTypes.bool,
};
FatalError.defaultProps = {
  error: '',
  hideRefresh: false,
};

export default FatalError;
